export const KPI_FIELDS = [
  { label: 'Total Lines of Code', name: 'linesOfCode' },
  { label: 'Total Packages', name: 'packages' },
  { label: 'Total High CVEs', name: 'highCVEs' },
  { label: 'Total Medium CVEs', name: 'mediumCVEs' },
  { label: 'Total Low CVEs', name: 'lowCVEs' },
  { label: 'License Compliance Risk', name: 'licenseComplianceRisk' },
];
